import theme from './theme';

// Object To define Color themes
export default {
  colorStyles: {
    red: {
      color: theme.colors.red,
      '&:hover, &:focus': {
        color: theme.colors.reds[1],
      },
    },
    blue: {
      color: theme.colors.blue,
      '&:hover, &:focus': {
        color: theme.colors.blues[1],
      },
    },
    white: {
      color: theme.colors.white,
      '&:hover, &:focus': {
        opacity: 0.8,
      },
    },
    transparent: {
      '&:hover, &:focus': {
        opacity: 0.8,
      },
    },
  },
};
